module.exports = __webpack_public_path__ + "static/media/obed-vecera.b44e1bec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/obed-vecera.jpg
// module id = 526
// module chunks = 0